import*as t from"react";import"../../../../../../../node_modules/react/jsx-runtime.js";const e=t.createContext(),o=()=>t.useContext(e)??!1;export{o as useRtl};
//# sourceMappingURL=index.js.map
